"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var publicTrackerClient = _interopRequireWildcard(require("usage-tracker-public"));

var _CommonTrackerProperties = _interopRequireDefault(require("pricing-pages-unified-ui/utils/CommonTrackerProperties"));

var _default = function _default() {
  return publicTrackerClient.createTracker(Object.assign({}, _CommonTrackerProperties.default, {
    isExternalHost: false
  }));
};

exports.default = _default;
module.exports = exports.default;